export const ENUM_REGEX = /ENUM{{(\d+)\|(.+?)}}/;

type ParseEnumerationStringResult =
  | { isEnumString: true; enumValue: number; enumName: string }
  | { isEnumString: false; enumValue: null; enumName: null };

export const parseEnumerationString = (value: string): ParseEnumerationStringResult => {
  const match = value.match(ENUM_REGEX);
  if (match === null) {
    return { isEnumString: false, enumValue: null, enumName: null };
  }
  return {
    isEnumString: true,
    enumValue: parseInt(match[1], 10),
    enumName: match[2],
  };
};
